import {Injectable} from "@angular/core";
import {CoreApiService} from "../../../core/service/core-api.service";
import {Observable} from "rxjs";
import {ApiResponseDto, ImageDto} from "../../../core/interfaces/core.types";

@Injectable({ providedIn: 'root' })
export abstract class InsurableObjectService {

  endPoint: string = "mvseu/eu/insurableObjects"

  constructor(
    protected coreApiService: CoreApiService) {
  }



  // public list() : Observable<InsurableObjectDto[]> {
  //   return this.coreApiService.getList(this.endPoint);
  // }
  //
  // public get(id: number) : Observable<InsurableObjectDto> {
  //   return this.coreApiService.get(`${this.endPoint}/single/${id}`);
  // }



  public postObjectImage(id: number, imageDto: ImageDto): Observable<any> {
    return this.coreApiService.post(imageDto, `${this.endPoint}/userObjectImage/${id}`);
  }

  public deleteObjectImage(id: number) : Observable<ApiResponseDto> {
    return this.coreApiService.delete(`${this.endPoint}/userObjectImage/${id}`);
  }

  public getObjectImage(id: number) : Observable<ImageDto> {
    return this.coreApiService.get(`${this.endPoint}/userObjectImage/${id}`);
  }


  public postPersonImage(id: number, imageDto: ImageDto): Observable<any> {
    return this.coreApiService.post(imageDto, `${this.endPoint}/userPersonImage/${id}`);
  }

  public deletePersonImage(id: number) : Observable<ApiResponseDto> {
    return this.coreApiService.delete(`${this.endPoint}/userPersonImage/${id}`);
  }

  public getPersonImage(id: number) : Observable<ImageDto> {
    return this.coreApiService.get(`${this.endPoint}/userPersonImage/${id}`);
  }
}
